import { render } from "./DeviceGradeModal.vue?vue&type=template&id=8520c63c&scoped=true&ts=true&lang=pug"
import script from "./DeviceGradeModal.vue?vue&type=script&lang=ts"
export * from "./DeviceGradeModal.vue?vue&type=script&lang=ts"

import "./DeviceGradeModal.vue?vue&type=style&index=0&id=8520c63c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8520c63c"]])

export default __exports__